<div class="ownership-selector {{isOpen ? 'ownership-selector-open' : ''}}">
    <div class="ownership-selector-selected {{selectedBG}}" tooltip="{{getOwnershipValue() | translate}}" placement="top" (click)="togglePanel()"><ng-content></ng-content></div>
    <div class="ownership-selector-options {{!isOpen ? 'hidden' : ''}}">
        <div class="ownership-selector-option-all" (click)="setSelected('All')">{{ 'ownership.all' | translate }}</div>
        <div class="ownership-selector-option-none" (click)="setSelected('None')">{{ 'ownership.none' | translate }}</div>
        <div class="ownership-selector-option-custom" (click)="setSelected('Custom')">{{ 'ownership.custom' | translate }}</div>
    </div>
</div>
<div *ngIf="isOpen" class="ownership-overlay" (click)="togglePanel()"></div>